import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import withRoot from '../withRoot';
import DiceUtil from '../utils/DiceUtil';
import { IconButton, Typography, ExpansionPanel, ExpansionPanelSummary, ExpansionPanelDetails, ListItem, ListItemText, ListItemSecondaryAction, List } from '@material-ui/core';
import CasinoIcon from '@material-ui/icons/Casino';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import AmmunitionTypes from './AmmunitionTypes.json';
import Switch from '@material-ui/core/Switch';

const styles = theme => ({
    root: {
        margin: theme.spacing.unit,
    },
    expansion: {
        width: "300px",
    },
    listText: {
        width: "180px",
    },
});

class AmmunitionTypeRoller extends Component {
    state = {
        result: null,
        availableTypes: Array(AmmunitionTypes.values.length).fill(true),
    };

    handleToggle = index => () => {
        const availableTypes = this.state.availableTypes.concat();
        availableTypes[index] = !availableTypes[index];
        this.setState({ availableTypes: availableTypes });
    };

    rollAmmunitionType() {
        const myAmmunitionTypes = [];
        for (let i = 0; i < AmmunitionTypes.values.length; i++) {
            if (this.state.availableTypes[i]) {
                myAmmunitionTypes[myAmmunitionTypes.length] = AmmunitionTypes.values[i];
            }
        }

        const roll = DiceUtil.dice(myAmmunitionTypes.length) - 1;
        this.setState({ result: myAmmunitionTypes[roll] });
    }

    render() {
        const { classes } = this.props;

        const ammunitionList = AmmunitionTypes.values.map((value, index) => (
            <ListItem key={index}>
                <ListItemText primary={value} className={classes.listText} />
                <ListItemSecondaryAction>
                    <Switch onChange={this.handleToggle(index)} checked={this.state.availableTypes[index]} />
                </ListItemSecondaryAction>
            </ListItem>
        ));

        return (
            <div className={classes.root}>
                <ExpansionPanel className={classes.expansion}>
                    <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                        <Typography>Filters</Typography>
                    </ExpansionPanelSummary>
                    <ExpansionPanelDetails>
                        <List>
                            {ammunitionList}
                        </List>
                    </ExpansionPanelDetails>
                </ExpansionPanel>

                <Typography>
                    <IconButton color="inherit" aria-label="Menu" onClick={() => this.rollAmmunitionType()}>
                        <CasinoIcon />
                    </IconButton>

                    {this.state.result}
                </Typography>
            </div>
        );
    }
}

AmmunitionTypeRoller.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withRoot("Ammunition Roller", withStyles(styles)(AmmunitionTypeRoller));


// WEBPACK FOOTER //
// ./src/item-helpers/AmmunitionTypeRoller.js